/* Numbered pagination — bordered boxes with prev/next arrows, centered. */
.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  font-family: Oxygen, sans-serif;
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 40px;
  height: 40px;
  padding: 0 10px;
  color: #333;
  font-size: 14px;
  text-decoration: none;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
}

.link:hover {
  background: #f5f5f5;
}

/* Current page filled grey to match the filter menu. */
.active .link {
  background: #ececed;
  font-weight: 700;
}

.filler {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 40px;
  color: #999;
}
